
import { defineComponent, ref } from 'vue'
import { ScopeDefinition, ScopeDefinitions } from '../../models/ScopeDefinition';

export default defineComponent({
    name: "Scope",
    setup() {
        let selectedScopes = ref(new Array<string>());
        let scopes = ref(new Array<ScopeDefinition>());
        let promptForScopes = ref(false);

        scopes.value.push(ScopeDefinitions.leads);
        scopes.value.push(ScopeDefinitions.broker);

        return {
            selectedScopes, scopes, promptForScopes
        }
    },
    //beforeMount() {
        // this.$store.state.axiosService.GetScopedDefinitions()
        //     .then((response : any) => {
        //         this.scopes = response;
        //     })
        //     .catch((response : any) => {
        //         console.log("Error getting scroped definitions.");
        //     });
    //},
    methods: {
        selectScope(newScopeName: string) {
            const scopeName = newScopeName;
            if (this.selectedScopes.indexOf(scopeName) > -1) {
                this.selectedScopes = this.selectedScopes.filter(x => x !== scopeName);
            }
            else {
                this.selectedScopes.push(scopeName);
            }
        },
        submitScopes() {
            if (this.selectedScopes.length === 0) {
                this.promptForScopes = true;
                return;
            }
            this.$router.push({ name:'Login', query:{ initiator: 'selfserve', scope: this.selectedScopes.join(' ')}})
        }
    }
})
